import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet, useNavigate } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";
import { useInactivityManager } from "../hooks/useInactivityManager";
import { useState } from "react";
import { usePreloadData } from "../hooks/usePreloadData";
import ChatwootScript from "../components/chatwoot/ChatwootScript";

const pageURL = `${import.meta.env.VITE_PAYLINK_BASE_URL}`;

const LayoutContent: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const navigate = useNavigate();

  usePreloadData();

  // Custom hook to track inactivity
  useInactivityManager({
    onLogout: () => setShowModal(true),
  });

  const handleModalClose = () => {
    setShowModal(false);
    navigate("/", { replace: true });
  };

  return (
    <>
      <div className="min-h-screen xl:flex relative">
        {/* Sidebar and backdrop */}
        <div>
          <AppSidebar />
          <Backdrop />
        </div>

        {/* Main content */}
        <div
          className={`flex-1 transition-all duration-300 ease-in-out ${
            isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
          } ${isMobileOpen ? "ml-0" : ""}`}
        >
          <AppHeader />
          <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
            <Outlet />
          </div>
        </div>
        
        <ChatwootScript pageURL={pageURL} />

        {/* Inactivity Modal */}
        {showModal && (
          <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white dark:bg-gray-800 p-6 rounded shadow-xl max-w-sm w-full mx-4">
              <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                You've been logged out
              </h2>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
                Due to inactivity, your session has expired. Please log in
                again.
              </p>
              <button
                onClick={handleModalClose}
                className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Okay
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const AppLayout: React.FC = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default AppLayout;
